import { useState, useEffect } from 'react';
import { isDeveloper } from '../firebase/firestore';

export const useDeveloper = (userId: string | null) => {
  const [isDeveloperUser, setIsDeveloperUser] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkDeveloperStatus = async () => {
      if (!userId) {
        setIsDeveloperUser(false);
        setLoading(false);
        return;
      }

      try {
        const developerStatus = await isDeveloper(userId);
        setIsDeveloperUser(developerStatus);
      } catch (error) {
        console.error('Error checking developer status:', error);
        setIsDeveloperUser(false);
      } finally {
        setLoading(false);
      }
    };

    checkDeveloperStatus();
  }, [userId]);

  return { isDeveloperUser, loading };
};

